import {AbstractModel, JsonObject, JsonProperty, DateConverter} from 'projects/core/src/public-api';
import {Project} from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import {User} from 'projects/core/src/lib/login/data/user';
import {ShortObject} from 'projects/app-misc/src/app/modules/project-misc/data/project/short-json-object';

@JsonObject('model.notifications.ClientNotification')
export class ClientNotification extends AbstractModel {

  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(String, 'clientMsg')
  clientMsg?: string;

  @JsonProperty(Project, 'project')
  project?: Project;

  @JsonProperty(Number, 'projectId')
  projectId: number;

  @JsonProperty(String, 'projectName')
  projectName?: string;

  @JsonProperty(String, 'message')
  message?: string;

  @JsonProperty(DateConverter, 'createdTime')
  createdTime?: Date;

  @JsonProperty(DateConverter, 'resolvedTime')
  resolvedTime?: Date;

  @JsonProperty(DateConverter, 'dismissed')
  dismissed?: Date;

  @JsonProperty(User, 'sentBy')
  sentBy?: User;

  @JsonProperty(String, 'sentTo')
  sentTo?: string;

  @JsonProperty(DateConverter, 'sentDate')
  sentDate?: Date;

  @JsonProperty(User, 'dismissedBy')
  dismissedBy?: User;

  @JsonProperty(ShortObject, 'condition')
  condition?: ShortObject;
}
